export default __webpack_public_path__ + "static/media/plus.d44b85ab.svg";